module.exports = __webpack_public_path__ + "img/4-mov.164fd337.png";